/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChangePassword } from '../model';
// @ts-ignore
import type { PdfReplyParameters } from '../model';
// @ts-ignore
import type { PortalPasswordResetValidationResult } from '../model';
// @ts-ignore
import type { PortalProperties } from '../model';
// @ts-ignore
import type { PortalSignupValidationResult } from '../model';
/**
 * PortalApi - axios parameter creator
 * @export
 */
export const PortalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} email 
         * @param {ChangePassword} changePassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerChangePortalPassword: async (email: string, changePassword: ChangePassword, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('portalControllerChangePortalPassword', 'email', email)
            // verify required parameter 'changePassword' is not null or undefined
            assertParamExists('portalControllerChangePortalPassword', 'changePassword', changePassword)
            const localVarPath = `/api/portal/changePortalPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePassword, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerForgotPassword: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('portalControllerForgotPassword', 'email', email)
            const localVarPath = `/api/portal/forgotPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {string} passwordID 
         * @param {number} passwordLength 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerGetOTPJSONCode: async (email: string, passwordID: string, passwordLength: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('portalControllerGetOTPJSONCode', 'email', email)
            // verify required parameter 'passwordID' is not null or undefined
            assertParamExists('portalControllerGetOTPJSONCode', 'passwordID', passwordID)
            // verify required parameter 'passwordLength' is not null or undefined
            assertParamExists('portalControllerGetOTPJSONCode', 'passwordLength', passwordLength)
            const localVarPath = `/api/portal/getOTPJSONCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (passwordID !== undefined) {
                localVarQueryParameter['passwordID'] = passwordID;
            }

            if (passwordLength !== undefined) {
                localVarQueryParameter['passwordLength'] = passwordLength;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {string} passwordID 
         * @param {number} passwordLength 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerGetOTPQRCode: async (email: string, passwordID: string, passwordLength: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('portalControllerGetOTPQRCode', 'email', email)
            // verify required parameter 'passwordID' is not null or undefined
            assertParamExists('portalControllerGetOTPQRCode', 'passwordID', passwordID)
            // verify required parameter 'passwordLength' is not null or undefined
            assertParamExists('portalControllerGetOTPQRCode', 'passwordLength', passwordLength)
            const localVarPath = `/api/portal/getOTPQRCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (passwordID !== undefined) {
                localVarQueryParameter['passwordID'] = passwordID;
            }

            if (passwordLength !== undefined) {
                localVarQueryParameter['passwordLength'] = passwordLength;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerGetOTPSecretKey: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('portalControllerGetOTPSecretKey', 'email', email)
            const localVarPath = `/api/portal/getOTPSecretKey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerGetOTPSecretKeyQRCode: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('portalControllerGetOTPSecretKeyQRCode', 'email', email)
            const localVarPath = `/api/portal/getOTPSecretKeyQRCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerGetPdfPassword: async (email: string, code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('portalControllerGetPdfPassword', 'email', email)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('portalControllerGetPdfPassword', 'code', code)
            const localVarPath = `/api/portal/getPdfPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} env 
         * @param {string} hmac 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerGetPdfReplyParameters: async (env: string, hmac: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'env' is not null or undefined
            assertParamExists('portalControllerGetPdfReplyParameters', 'env', env)
            // verify required parameter 'hmac' is not null or undefined
            assertParamExists('portalControllerGetPdfReplyParameters', 'hmac', hmac)
            const localVarPath = `/api/portal/getPdfReplyParameters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (env !== undefined) {
                localVarQueryParameter['env'] = env;
            }

            if (hmac !== undefined) {
                localVarQueryParameter['hmac'] = hmac;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sender 
         * @param {string} replyRecipient 
         * @param {string} replySender 
         * @param {string} subject 
         * @param {string} [messageID] 
         * @param {number} [maxSubjectLength] 
         * @param {string} [baseURL] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerGetPdfReplyURL: async (sender: string, replyRecipient: string, replySender: string, subject: string, messageID?: string, maxSubjectLength?: number, baseURL?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sender' is not null or undefined
            assertParamExists('portalControllerGetPdfReplyURL', 'sender', sender)
            // verify required parameter 'replyRecipient' is not null or undefined
            assertParamExists('portalControllerGetPdfReplyURL', 'replyRecipient', replyRecipient)
            // verify required parameter 'replySender' is not null or undefined
            assertParamExists('portalControllerGetPdfReplyURL', 'replySender', replySender)
            // verify required parameter 'subject' is not null or undefined
            assertParamExists('portalControllerGetPdfReplyURL', 'subject', subject)
            const localVarPath = `/api/portal/getPdfReplyURL`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (sender !== undefined) {
                localVarQueryParameter['sender'] = sender;
            }

            if (replyRecipient !== undefined) {
                localVarQueryParameter['replyRecipient'] = replyRecipient;
            }

            if (replySender !== undefined) {
                localVarQueryParameter['replySender'] = replySender;
            }

            if (subject !== undefined) {
                localVarQueryParameter['subject'] = subject;
            }

            if (messageID !== undefined) {
                localVarQueryParameter['messageID'] = messageID;
            }

            if (maxSubjectLength !== undefined) {
                localVarQueryParameter['maxSubjectLength'] = maxSubjectLength;
            }

            if (baseURL !== undefined) {
                localVarQueryParameter['baseURL'] = baseURL;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerGetPortalProperties: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('portalControllerGetPortalProperties', 'email', email)
            const localVarPath = `/api/portal/getPortalProperties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerIsPortalUser: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('portalControllerIsPortalUser', 'email', email)
            const localVarPath = `/api/portal/isPortalUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resetCode 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerResetPortalPassword: async (resetCode: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetCode' is not null or undefined
            assertParamExists('portalControllerResetPortalPassword', 'resetCode', resetCode)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('portalControllerResetPortalPassword', 'body', body)
            const localVarPath = `/api/portal/resetPortalPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (resetCode !== undefined) {
                localVarQueryParameter['resetCode'] = resetCode;
            }


    
            localVarHeaderParameter['Content-Type'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} recipient 
         * @param {string} from 
         * @param {string} [sender] 
         * @param {string} [phoneNumber] 
         * @param {boolean} [recipientEnableOTP] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerSendOTPSecretByEmail: async (recipient: string, from: string, sender?: string, phoneNumber?: string, recipientEnableOTP?: boolean, body?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipient' is not null or undefined
            assertParamExists('portalControllerSendOTPSecretByEmail', 'recipient', recipient)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('portalControllerSendOTPSecretByEmail', 'from', from)
            const localVarPath = `/api/portal/sendOTPSecretByEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (recipient !== undefined) {
                localVarQueryParameter['recipient'] = recipient;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (sender !== undefined) {
                localVarQueryParameter['sender'] = sender;
            }

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phoneNumber'] = phoneNumber;
            }

            if (recipientEnableOTP !== undefined) {
                localVarQueryParameter['recipientEnableOTP'] = recipientEnableOTP;
            }


    
            localVarHeaderParameter['Content-Type'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {boolean} enable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerSet2FAEnabled: async (email: string, enable: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('portalControllerSet2FAEnabled', 'email', email)
            // verify required parameter 'enable' is not null or undefined
            assertParamExists('portalControllerSet2FAEnabled', 'enable', enable)
            const localVarPath = `/api/portal/set2FAEnabled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (enable !== undefined) {
                localVarQueryParameter['enable'] = enable;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerSet2FASecret: async (email: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('portalControllerSet2FASecret', 'email', email)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('portalControllerSet2FASecret', 'body', body)
            const localVarPath = `/api/portal/set2FASecret`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            localVarHeaderParameter['Content-Type'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} signupCode 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerSetPortalSignupPassword: async (signupCode: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signupCode' is not null or undefined
            assertParamExists('portalControllerSetPortalSignupPassword', 'signupCode', signupCode)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('portalControllerSetPortalSignupPassword', 'body', body)
            const localVarPath = `/api/portal/setPortalSignupPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (signupCode !== undefined) {
                localVarQueryParameter['signupCode'] = signupCode;
            }


    
            localVarHeaderParameter['Content-Type'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resetCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerValidatePortalPasswordReset: async (resetCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetCode' is not null or undefined
            assertParamExists('portalControllerValidatePortalPasswordReset', 'resetCode', resetCode)
            const localVarPath = `/api/portal/validatePortalPasswordReset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (resetCode !== undefined) {
                localVarQueryParameter['resetCode'] = resetCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} signupCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerValidatePortalSignup: async (signupCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signupCode' is not null or undefined
            assertParamExists('portalControllerValidatePortalSignup', 'signupCode', signupCode)
            const localVarPath = `/api/portal/validatePortalSignup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (signupCode !== undefined) {
                localVarQueryParameter['signupCode'] = signupCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortalApi - functional programming interface
 * @export
 */
export const PortalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} email 
         * @param {ChangePassword} changePassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerChangePortalPassword(email: string, changePassword: ChangePassword, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerChangePortalPassword(email, changePassword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerChangePortalPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerForgotPassword(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerForgotPassword(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerForgotPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {string} passwordID 
         * @param {number} passwordLength 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerGetOTPJSONCode(email: string, passwordID: string, passwordLength: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerGetOTPJSONCode(email, passwordID, passwordLength, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerGetOTPJSONCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {string} passwordID 
         * @param {number} passwordLength 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerGetOTPQRCode(email: string, passwordID: string, passwordLength: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerGetOTPQRCode(email, passwordID, passwordLength, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerGetOTPQRCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerGetOTPSecretKey(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerGetOTPSecretKey(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerGetOTPSecretKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerGetOTPSecretKeyQRCode(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerGetOTPSecretKeyQRCode(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerGetOTPSecretKeyQRCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerGetPdfPassword(email: string, code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerGetPdfPassword(email, code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerGetPdfPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} env 
         * @param {string} hmac 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerGetPdfReplyParameters(env: string, hmac: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfReplyParameters>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerGetPdfReplyParameters(env, hmac, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerGetPdfReplyParameters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sender 
         * @param {string} replyRecipient 
         * @param {string} replySender 
         * @param {string} subject 
         * @param {string} [messageID] 
         * @param {number} [maxSubjectLength] 
         * @param {string} [baseURL] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerGetPdfReplyURL(sender: string, replyRecipient: string, replySender: string, subject: string, messageID?: string, maxSubjectLength?: number, baseURL?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerGetPdfReplyURL(sender, replyRecipient, replySender, subject, messageID, maxSubjectLength, baseURL, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerGetPdfReplyURL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerGetPortalProperties(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortalProperties>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerGetPortalProperties(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerGetPortalProperties']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerIsPortalUser(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerIsPortalUser(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerIsPortalUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resetCode 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerResetPortalPassword(resetCode: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortalPasswordResetValidationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerResetPortalPassword(resetCode, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerResetPortalPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} recipient 
         * @param {string} from 
         * @param {string} [sender] 
         * @param {string} [phoneNumber] 
         * @param {boolean} [recipientEnableOTP] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerSendOTPSecretByEmail(recipient: string, from: string, sender?: string, phoneNumber?: string, recipientEnableOTP?: boolean, body?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerSendOTPSecretByEmail(recipient, from, sender, phoneNumber, recipientEnableOTP, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerSendOTPSecretByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {boolean} enable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerSet2FAEnabled(email: string, enable: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerSet2FAEnabled(email, enable, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerSet2FAEnabled']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerSet2FASecret(email: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerSet2FASecret(email, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerSet2FASecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} signupCode 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerSetPortalSignupPassword(signupCode: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortalSignupValidationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerSetPortalSignupPassword(signupCode, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerSetPortalSignupPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resetCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerValidatePortalPasswordReset(resetCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortalPasswordResetValidationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerValidatePortalPasswordReset(resetCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerValidatePortalPasswordReset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} signupCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerValidatePortalSignup(signupCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortalSignupValidationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerValidatePortalSignup(signupCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerValidatePortalSignup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PortalApi - factory interface
 * @export
 */
export const PortalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortalApiFp(configuration)
    return {
        /**
         * 
         * @param {string} email 
         * @param {ChangePassword} changePassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerChangePortalPassword(email: string, changePassword: ChangePassword, options?: any): AxiosPromise<void> {
            return localVarFp.portalControllerChangePortalPassword(email, changePassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerForgotPassword(email: string, options?: any): AxiosPromise<void> {
            return localVarFp.portalControllerForgotPassword(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {string} passwordID 
         * @param {number} passwordLength 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerGetOTPJSONCode(email: string, passwordID: string, passwordLength: number, options?: any): AxiosPromise<string> {
            return localVarFp.portalControllerGetOTPJSONCode(email, passwordID, passwordLength, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {string} passwordID 
         * @param {number} passwordLength 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerGetOTPQRCode(email: string, passwordID: string, passwordLength: number, options?: any): AxiosPromise<string> {
            return localVarFp.portalControllerGetOTPQRCode(email, passwordID, passwordLength, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerGetOTPSecretKey(email: string, options?: any): AxiosPromise<string> {
            return localVarFp.portalControllerGetOTPSecretKey(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerGetOTPSecretKeyQRCode(email: string, options?: any): AxiosPromise<string> {
            return localVarFp.portalControllerGetOTPSecretKeyQRCode(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerGetPdfPassword(email: string, code: string, options?: any): AxiosPromise<string> {
            return localVarFp.portalControllerGetPdfPassword(email, code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} env 
         * @param {string} hmac 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerGetPdfReplyParameters(env: string, hmac: string, options?: any): AxiosPromise<PdfReplyParameters> {
            return localVarFp.portalControllerGetPdfReplyParameters(env, hmac, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sender 
         * @param {string} replyRecipient 
         * @param {string} replySender 
         * @param {string} subject 
         * @param {string} [messageID] 
         * @param {number} [maxSubjectLength] 
         * @param {string} [baseURL] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerGetPdfReplyURL(sender: string, replyRecipient: string, replySender: string, subject: string, messageID?: string, maxSubjectLength?: number, baseURL?: string, options?: any): AxiosPromise<string> {
            return localVarFp.portalControllerGetPdfReplyURL(sender, replyRecipient, replySender, subject, messageID, maxSubjectLength, baseURL, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerGetPortalProperties(email: string, options?: any): AxiosPromise<PortalProperties> {
            return localVarFp.portalControllerGetPortalProperties(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerIsPortalUser(email: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.portalControllerIsPortalUser(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} resetCode 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerResetPortalPassword(resetCode: string, body: string, options?: any): AxiosPromise<PortalPasswordResetValidationResult> {
            return localVarFp.portalControllerResetPortalPassword(resetCode, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} recipient 
         * @param {string} from 
         * @param {string} [sender] 
         * @param {string} [phoneNumber] 
         * @param {boolean} [recipientEnableOTP] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerSendOTPSecretByEmail(recipient: string, from: string, sender?: string, phoneNumber?: string, recipientEnableOTP?: boolean, body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.portalControllerSendOTPSecretByEmail(recipient, from, sender, phoneNumber, recipientEnableOTP, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {boolean} enable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerSet2FAEnabled(email: string, enable: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.portalControllerSet2FAEnabled(email, enable, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerSet2FASecret(email: string, body: string, options?: any): AxiosPromise<void> {
            return localVarFp.portalControllerSet2FASecret(email, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} signupCode 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerSetPortalSignupPassword(signupCode: string, body: string, options?: any): AxiosPromise<PortalSignupValidationResult> {
            return localVarFp.portalControllerSetPortalSignupPassword(signupCode, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} resetCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerValidatePortalPasswordReset(resetCode: string, options?: any): AxiosPromise<PortalPasswordResetValidationResult> {
            return localVarFp.portalControllerValidatePortalPasswordReset(resetCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} signupCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerValidatePortalSignup(signupCode: string, options?: any): AxiosPromise<PortalSignupValidationResult> {
            return localVarFp.portalControllerValidatePortalSignup(signupCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PortalApi - object-oriented interface
 * @export
 * @class PortalApi
 * @extends {BaseAPI}
 */
export class PortalApi extends BaseAPI {
    /**
     * 
     * @param {string} email 
     * @param {ChangePassword} changePassword 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerChangePortalPassword(email: string, changePassword: ChangePassword, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerChangePortalPassword(email, changePassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerForgotPassword(email: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerForgotPassword(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {string} passwordID 
     * @param {number} passwordLength 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerGetOTPJSONCode(email: string, passwordID: string, passwordLength: number, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerGetOTPJSONCode(email, passwordID, passwordLength, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {string} passwordID 
     * @param {number} passwordLength 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerGetOTPQRCode(email: string, passwordID: string, passwordLength: number, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerGetOTPQRCode(email, passwordID, passwordLength, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerGetOTPSecretKey(email: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerGetOTPSecretKey(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerGetOTPSecretKeyQRCode(email: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerGetOTPSecretKeyQRCode(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerGetPdfPassword(email: string, code: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerGetPdfPassword(email, code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} env 
     * @param {string} hmac 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerGetPdfReplyParameters(env: string, hmac: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerGetPdfReplyParameters(env, hmac, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sender 
     * @param {string} replyRecipient 
     * @param {string} replySender 
     * @param {string} subject 
     * @param {string} [messageID] 
     * @param {number} [maxSubjectLength] 
     * @param {string} [baseURL] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerGetPdfReplyURL(sender: string, replyRecipient: string, replySender: string, subject: string, messageID?: string, maxSubjectLength?: number, baseURL?: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerGetPdfReplyURL(sender, replyRecipient, replySender, subject, messageID, maxSubjectLength, baseURL, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerGetPortalProperties(email: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerGetPortalProperties(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerIsPortalUser(email: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerIsPortalUser(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} resetCode 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerResetPortalPassword(resetCode: string, body: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerResetPortalPassword(resetCode, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} recipient 
     * @param {string} from 
     * @param {string} [sender] 
     * @param {string} [phoneNumber] 
     * @param {boolean} [recipientEnableOTP] 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerSendOTPSecretByEmail(recipient: string, from: string, sender?: string, phoneNumber?: string, recipientEnableOTP?: boolean, body?: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerSendOTPSecretByEmail(recipient, from, sender, phoneNumber, recipientEnableOTP, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {boolean} enable 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerSet2FAEnabled(email: string, enable: boolean, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerSet2FAEnabled(email, enable, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerSet2FASecret(email: string, body: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerSet2FASecret(email, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} signupCode 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerSetPortalSignupPassword(signupCode: string, body: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerSetPortalSignupPassword(signupCode, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} resetCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerValidatePortalPasswordReset(resetCode: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerValidatePortalPasswordReset(resetCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} signupCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public portalControllerValidatePortalSignup(signupCode: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerValidatePortalSignup(signupCode, options).then((request) => request(this.axios, this.basePath));
    }
}

